import { useEffect, useRef } from "react";
import { wsUrl } from "@/lib/api";

// Subscribes to realtime signals. onMessage receives the parsed message object.
export function useRealtime(onMessage) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    let ws;
    let closed = false;
    let retry;

    const connect = () => {
      try {
        ws = new WebSocket(wsUrl());
      } catch (e) {
        return;
      }
      ws.onmessage = (ev) => {
        try {
          cbRef.current(JSON.parse(ev.data));
        } catch (e) {
          /* ignore */
        }
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 2500);
      };
      ws.onerror = () => {
        try { ws.close(); } catch (e) {}
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      if (ws) try { ws.close(); } catch (e) {}
    };
  }, []);
}
